import { Component, HostListener, OnInit } from '@angular/core';
import { DataService } from './shared/data.service';
import { CookieService } from './shared/cookie.service';
import { UserService } from './shared/user.service';
import { User } from './shared/user.model';
declare var $: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  constructor(private cookieService: CookieService, private dataService: DataService, private userService: UserService){
    if (window.location.href.includes('localhost')){
      console.log('local');
      setTimeout(() => {
        this.dataService.setUserToken("aRyARqsfJ/GdVCDrnBKIKaAyCW4bBPuZQTQrbvVcDcZKpcqd9CAkzg4z6TRnFROm8mJEQRnvTNW5LmU/hCQ7qaYqMIH3U13t5hY0KKg2g1k=");
        this.userService.setUser(new User('Trent Grandey', '312227', 'PPAI', '304174', 'TA', 'trentg@ppai.org', true))
      }, 1000);
    } else {
      console.log('live');
      let c = this.cookieService.get("sso");
      if (c == null || c.length == 0)
        window.location.href = 'https://login.ppai.org?returnurl=https://directory.ppai.org/';
      this.dataService.loadUser(c).subscribe();
    }
  }
  ngOnInit() {
    this.onWindowResize();
  }
  
  @HostListener("window:resize", [])
  onWindowResize() {
    var w = $(window).width();
    if (w <= 1200) {
      $('#filtercollapser,#altsearchescollapser').attr('data-toggle', 'collapse');
      $('#filters,#altsearches').addClass('collapse');
      $('#filters,#altsearches').removeClass('in');
    } else {
      $('#filters,#altsearches').removeClass('collapse');
      $('#filters,#altsearches').addClass('in');
      $('#filtercollapser,#altsearchescollapser').removeAttr('data-toggle', 'collapse');
    }
  }

  title = 'IndustryDirectory';
}
